import { TXIconTemplate } from "../../../types/common/templates.types";

export const X_ICON_TEMPLATES: TXIconTemplate = {
  "Icone Par Defaut": {
    template: [
      {
        name: "XIcon",
        props: { all: { icon: "favorite" } },
      },
    ],
  },
};
